<template>
  <div>
    <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="500px">
      <v-card>
        <v-toolbar dense class="">
          <v-toolbar-title>Add to Pairing Influencer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
          <!-- Popup content -->
          <v-card>
            <v-card-text>
              <v-autocomplete
                filled
                :items="campaigns"
                label="Select Campaign"
                item-value="id"
                hide-details
                item-text="name"
                v-model="selectedCampaign"
              >
              </v-autocomplete>
              <v-row class="pt-2">
                <v-col>
                  <v-list-item class="pa-0">
                    <v-list-item-content>
                      <v-list-item-subtitle :key="index" v-for="(inf, index) in selectedInfluencers">
                        <v-icon color="green" small>mdi-check</v-icon>
                        <a
                          target="_blank"
                          v-bind:href="'https://www.tiktok.com/@' + inf.instagramHandle"
                          v-if="inf.platform === 'tiktok'"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{ inf.instagramHandle }}</a>
                        <a
                          target="_blank"
                          v-bind:href="'https://instagram.com/' + inf.instagramHandle"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ inf.instagramHandle }}</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- Footer -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeModal"> Close </v-btn>
              <v-btn class="success" :disabled="!selectedCampaign" @click="addtoPairing">Save changes</v-btn>
            </v-card-actions>
          </v-card>
      </v-card>
      <!-- <v-dialog v-model="loading" hide-overlay persistent width="250">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog> -->
    </v-dialog>
    <!-- Full Screen Progress Loading Dialog -->
    <full-screen-progress 
    :show="bulkProgress.show" 
    isStatus="true"
    :processing="bulkProgress.processing" 
    :complete="bulkProgress.complete"
    :color="secondary" />
    <!-- Full Screen Progress Loading Dialog -->
  </div>
</template>
<script>
import campaignAPIs from '../Campaign/campaignAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
import config from '@/config';
import utils from '../../../utils';
import FullScreenProgress from '../../scoped/custom/FullScreenProgress';
export default {
  name: 'AddInfluencerPairingModal',
  props: {
    selectedInfluencers: Array,
    value: Boolean
  },
  components: {
    FullScreenProgress
  },
  data () {
    return {
      campaigns: [],
      selectedCampaign: '',
      selected: [],
      loading: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      }
    }
  },
  computed: {
  },
  async mounted() {
    this.getCampaigns() // refreshCampaign
  },
  methods: {
    async savePairing() {
      console.log('save pairing')
      // const formData = this.buildFormData()
      // this.loading = true
      // try {
      //   let response = await campaignAPIs.addReportGroup(formData)
      //   if (response) {
      //     this.getReportGroups()
      //     // Return the newly added data to parent component
      //     this.loading = false;
      //     this.$swal({
      //       title: 'Successful',
      //       text: `Reports are added to (${response.group.name || '-'})`,
      //       type: 'success'
      //     }).then(() => {
      //       this.$emit('input')
      //       this.$emit('saved', true);
      //     });
      //   }
      // } catch (error) {
      //   this.loading = false;
      //   this.$swal({
      //     title: 'Error',
      //     text: error,
      //     type: 'error'
      //   });
      //   console.log('error', error);
      // }
    },
    buildFormData() {
      // if (typeof this.selectedGroup === 'string') {
      //   this.selectedGroup = {id: 0, name: this.selectedGroup}
      // }
      let formData = new FormData();
      formData.append('group', JSON.stringify(this.selectedGroup));
      formData.append('reports', JSON.stringify(this.selectedPosts.map(c => c.id)));
      return formData
    },
    closeModal() {
      this.$emit('input')
      this.selectedGroup = ''
    },
    async getCampaigns() {
      try {
        campaignAPIs
        .getAllCampaignsNoStatus() // In future, Campaign status could be change
        .then(response => {
          this.campaigns = response.filter(c => (c.status === config.campaignStatus.ONGOING || c.status === config.campaignStatus.PAIRING_INFLUENCER))
          this.campaigns = this.campaigns.map(element => {
            return {
              name: element.name,
              id: element.id
            };
          });
        })
        .catch(err => {
          console.log('Error:' + err);
        });
      } catch (error) {
        console.error(error);
      }
    },
    async addtoPairing() {
      await this.getPairedInfluencers(this.selectedCampaign)
      if (this.selectedInfluencers.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'No Influencer Selected.'
        });
        return;
      }
      let vm = this
      let handleItems = this.selectedInfluencers.map(inf =>
        Object.assign({}, {
          handle: inf.instagramHandle,
          platform: inf.platform
        })
      )
      this.resetBulkProgress()
      this.bulkProgress.show = true
      this.bulkProgress.complete = handleItems.length
      let importSelected = []
      let added = []
      let interval = 100
      handleItems.forEach(async (el, index) => {
        setTimeout(async () => {
          let handleItem = el
          if (vm.selected.find(e => e.handle === handleItem.handle && e.platform === el.platform)) {
            importSelected.push({handle: handleItem.handle, platform: handleItem.platform})
          } else {
            await pairingAPIs.crawlInfluencerDetails({userHandle: handleItem.handle, campaignID: this.selectedCampaign, platform: handleItem.platform.toLowerCase()})
            utils.func.pushPairingElementToArray(this.selected, {handle: handleItem.handle, platform: handleItem.platform}, 'handle', 'object', handleItem.platform);
            added.push({handle: handleItem.handle, platform: handleItem.platform})
            console.log(`🚀 ~ Handle: ${handleItem.handle}`)
          }
          this.bulkProgress.processing = index + 1
          if (this.bulkProgress.complete === this.bulkProgress.processing) {
            this.bulkProgress.show = false
            this.showSuccessMessage(importSelected, added)
          }
        }, index * interval);
      });
    },
    resetBulkProgress() {
      this.bulkProgress.processing = 0
      this.bulkProgress.complete = 0
      this.bulkProgress.show = false
    },
    async getPairedInfluencers(campaignID) {
      try {
        let resp = await pairingAPIs.getPairedInfluencersByCampaign(campaignID)
        if (resp) {
          let selected = [];
          for (let data of resp) {
            let inf = data.influencer_details;
            inf.platform = inf.platform || 'instagram'
            selected.push({handle: inf.instagramHandle, platform: inf.platform});
          }
          this.selected = Object.assign([], selected);
        }
      } catch (error) {
        console.error(error);
      }
    },
    showSuccessMessage(importSelected, added) {
      let displayBlock = ''
      if (importSelected.length > 0) { // if already selected exists, show after completed
        importSelected.map(a => {
          displayBlock += `<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">
            <span class="v-chip__content">${a.handle}</span>
          </span>`
        })
        this.$swal({
          title: 'Error!',
          icon: 'error',
          showCancelButton: false,
          html: `Influencer(s) can be found in pairing for this campaign <div>${displayBlock}</div>`
        }).then(() => {
          this.$emit('input')
        });
      } else {
        added.map(a => {
          displayBlock += `<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:green;color:#fff">
            <span class="v-chip__content">${a.handle}</span>
          </span>`
        })
        this.$swal({
          title: 'Successful',
          html: `Influencers added: <div>${displayBlock}</div>`,
          type: 'success'
        }).then(() => {
          this.$emit('input')
        });
      }
      return;
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddInfluencerPairingModal.vue?0605b494